export default function clientConfig() {
  const config = {
    codCliente: 9162, // 8162 - implantação | 2162 - PRD | 9162 - HMG
    plano: 1,
    tipo: 1,
  }

  return config
}
